module.exports = __webpack_public_path__ + "assets/629ed66c2bda1077d3a6c9499c7ad090.png";